import { useLocalStorage, useSessionStorage } from "@vueuse/core";
import { defineStore } from "pinia";

export const usePropsStore = defineStore("props", {
  state: () => ({
    api: useSessionStorage("api", ""),
    clientName: useSessionStorage("clientName", ""),
    darkMode: useLocalStorage("darkMode", false),
    theme: useLocalStorage("theme", "default"),
    traceApiCalls: useLocalStorage("traceApiCalls", false),
    maxFileSize: useLocalStorage("maxFileSize", 104857600),
    ssoEnabled: useSessionStorage("ssoEnabled", false),
    ssoDomain: useSessionStorage("ssoDomain", ""),
    ssoClientId: useSessionStorage("ssoClientId", ""),
    ssoIssuer: useSessionStorage("ssoIssuer", ""),
    ssoJwksUri: useSessionStorage("ssoJwksUri", ""),
    ssoEndSessionEndpoint: useSessionStorage("ssoEndSessionEndpoint", ""),
    ssoAuthorizationEnpoint: useSessionStorage("ssoAuthorizationEnpoint", ""),
    ssoTokenEndpoint: useSessionStorage("ssoTokenEndpoint", ""),
    logo: useSessionStorage("login", "/images/login.png"),
    loginBg: useSessionStorage("loginBg", "/images/login-bg.jpg"),
    searchText: useSessionStorage("searchText", ""),
    demo: useSessionStorage("demo", false),
    streamline: useSessionStorage("streamline", false),
  }),
});
